/**
 * The examiner's voice, re-encoded for an avatar provider: both take raw
 * mono PCM16, Simli at 16 kHz and LiveAvatar at 24 kHz, while our speech
 * arrives as mp3. The browser decodes it once (useSpeechPlayback) and this
 * resamples and converts it.
 */

/** Float samples in [-1, 1] to little-endian 16-bit PCM bytes. */
export function floatTo16BitPcm(samples) {
  const out = new Uint8Array(samples.length * 2);
  const view = new DataView(out.buffer);
  for (let i = 0; i < samples.length; i += 1) {
    const s = Math.max(-1, Math.min(1, samples[i]));
    view.setInt16(i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  }
  return out;
}

/** A decoded AudioBuffer, resampled to mono at sampleRate, as PCM16 bytes. */
export async function toPcm16(audioBuffer, sampleRate) {
  const Offline = window.OfflineAudioContext || window.webkitOfflineAudioContext;
  const ctx = new Offline(1, Math.max(1, Math.ceil(audioBuffer.duration * sampleRate)), sampleRate);
  const source = ctx.createBufferSource();
  source.buffer = audioBuffer;
  source.connect(ctx.destination);
  source.start(0);
  const rendered = await ctx.startRendering();
  return floatTo16BitPcm(rendered.getChannelData(0));
}

export function bytesToBase64(bytes) {
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
}
